/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Component } from '@angular/core';
import { SavedCartDetailsActionComponent } from '@spartacus/cart/saved-cart/components';

@Component({
  selector: 'cx-saved-cart-details-action',
  templateUrl: './saved-cart-details-action.component.html',
  styleUrls: ['./saved-cart-details-action.component.scss'],
  standalone: false,
})
export class CustomSavedCartDetailsActionComponent extends SavedCartDetailsActionComponent {}
